import { CellClassParams } from 'ag-grid/dist/lib/entities/colDef';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CellDoubleClickedEvent, GridOptions } from 'ag-grid';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { modalSwal } from 'app/utils/helpers';
import { IMyOptions } from 'mydatepicker';
import { Subscription } from 'rxjs/Subscription';
import { ComplaintsService } from '../../../../../services/complaints.service';
import { messagePermits } from '../../../../A2-utils/export-functions/functions-services';
import * as moment from 'moment';

@Component({
  selector: 'app-grid-complaint',
  templateUrl: './grid-complaint.component.html',
  styleUrls: ['./grid-complaint.component.scss']
})
export class GridComplaintComponent implements OnInit, OnChanges, OnDestroy {

  @Output() onOpenManager?: EventEmitter<any> = new EventEmitter();
  @Input() onReload?: any;
  @Input() actionsComplaints: string[] = [];

  protected gridTrips: GridOptions;

  public myRDPOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false,
  };
  protected dateRangeExport: any;
  private ptrDateBegin: any;
  private ptrDateEnd: any;
  private noteStatusId: any;
  private isdateofservice: boolean;

  public status: any = [];
  complaints: any = [];
  subscription: Subscription[] = [];
  constructor(
    private complaintsService: ComplaintsService,
    protected _loading: T2LoadingService
  ) {
    this.initGrid();
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subs) => subs.unsubscribe());
  }

  ngOnInit() {
    this.getStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['onReload'] && this.onReload !== undefined) {
      this.onFind();
    }
  }

  initGrid(): void {
    this.gridTrips = <GridOptions>{
      enableSorting: true,
      enableColResize: true,
      enableFilter: true,
      sortingOrder: ['desc', 'asc', null],
      columnDefs: [
        {
          headerName: 'Trip',
          field: 'trip.consecutive',
          colId: 'tripid',
          width: 70,
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: 'DOS',
          field: 'trip.dateofserviceformatted',
          colId: 'tripdate',
          width: 80,
          cellRenderer: (params: CellClassParams) => {
            if (params && params.data && params.data.trip) {
              const { dateofserviceformatted } = params.data.trip;
              return moment(dateofserviceformatted).format('MM-DD-YYYY');
            }
          }
        },
        {
          headerName: 'Date Complaint',
          field: 'note.date',
          width: 80
        },
        {
          headerName: 'Region',
          field: 'trip.tripregionpu',
          colId: 'tripregionpu',
          width: 70,
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: 'Member',
          field: 'trip.fullname',
          width: 120
        },
        {
          headerName: 'Category',
          field: 'note.notecomplaint',
          colId: 'Trip'
          ,
          width: 80
        },
        {
          headerName: 'Status',
          field: 'note.notestatus',
          width: 80
        },
        {
          headerName: 'Leg',
          field: 'trip.leg',
          width: 45
        },
        {
          headerName: 'Driver',
          field: 'trip.driverfullname',
          width: 80
        },
        {
          headerName: 'Entered By',
          field: 'note.adminuser.fullname',
          colId: 'Trip',
          width: 80
        },
        {
          headerName: 'Payor',
          field: 'trip.payor.description',
          width: 80
        },
        {
          headerName: 'Provider',
          field: 'note.provider.speedcode',
          width: 75
        },
        {
          headerName: 'Member Id',
          field: 'trip.memberid',
          width: 85
        },
        {
          headerName: 'Review Status',
          field: 'note.lastreviewstatus',
          width: 100
        },
      ],
      onGridReady: () => {
        if (this.gridTrips && this.gridTrips.api) {
          this.gridTrips.api.setRowData([]);
        }
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params && params.data) {
          const { tripnoteid, trip: { consecutive } } = params.data;
          this.onOpenManager.emit({ tripnoteid, consecutive });
        }
      }
    };
  }

  /**
   * @name onDateExportSelected
   * @description
   * @param event
   */
  onDateRangeChanged(event) {
    if (event.beginEpoc !== 0 && event.endEpoc !== 0) {
      this.ptrDateBegin = event.beginDate.year + '-' + event.beginDate.month + '-' + event.beginDate.day;
      this.ptrDateEnd = event.endDate.year + '-' + event.endDate.month + '-' + event.endDate.day;
    } else {
      this.restartField();
    }
  }

  restartField() {
    this.ptrDateBegin = null;
    this.ptrDateEnd = null;
    this.dateRangeExport = null;
  }

  getStatus() {
    this.subscription.push(
      this.complaintsService.getStatus().subscribe((statusData) => {
        this.status = statusData;
      })
    );
  }

  onFind() {
    this._loading.show();
    if (this.actionsComplaints.includes('View')) {
      this.subscription.push(
        this.complaintsService.getComplaints(this.ptrDateBegin, this.ptrDateEnd, this.noteStatusId, this.isdateofservice)
        .subscribe((complaintsData) => {
          this.complaints = complaintsData;
          this.gridTrips.api.setRowData(this.complaints);
          this._loading.hiden();
        },
        (error) => {
          modalSwal('Error', 'error', error.messagedetail).then(() => {
            this._loading.hiden();
            this.gridTrips.api.setRowData([]);
          });
        })
      );
    } else {
      this._loading.hiden();
      messagePermits('View Complaints');
    }
  }

  get disabledBtn(): boolean {
    return !this.dateRangeExport || !this.isdateofservice;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-resolution/components/grid-complaint/grid-complaint.component.ts